module.exports = __webpack_public_path__ + "dash_20_app_assets/img/feedbackdone.2cc16fb4.png";